import { useIntl } from 'react-intl';
import type { SegmentedControlFilterConfigV2 } from '../../components/FilterControlV2/types';
import type TrailEngagement from '../../types/TrailEngagement';

type MyTrailsSegmentedConfig = {
  completedConfig: SegmentedControlFilterConfigV2;
  savedConfig: SegmentedControlFilterConfigV2;
};

const ALL = 'all';

const useMyTrailsSegmentedConfig = (
  trailEngagement: TrailEngagement[] = [],
  onTrailEngagementChange: (trailEngagement: TrailEngagement[]) => void
): MyTrailsSegmentedConfig => {
  const intl = useIntl();

  const savedActiveId = trailEngagement.includes('saved') ? 'saved' : trailEngagement.includes('not_saved') ? 'not_saved' : ALL;
  const completedActiveId = trailEngagement.includes('completed') ? 'completed' : trailEngagement.includes('not_completed') ? 'not_completed' : ALL;

  const savedConfig: SegmentedControlFilterConfigV2 = {
    type: 'segmented-control',
    id: 'saved-status',
    segmentedControl: {
      activeId: savedActiveId,
      ariaLabel: intl.formatMessage({ defaultMessage: 'Saved status' }),
      options: [
        { id: ALL, label: intl.formatMessage({ defaultMessage: 'All' }) },
        { id: 'saved', label: intl.formatMessage({ defaultMessage: 'Saved' }) },
        { id: 'not_saved', label: intl.formatMessage({ defaultMessage: 'Not saved' }) }
      ],
      onChange: id => {
        const rest = trailEngagement.filter(engagement => engagement !== 'saved' && engagement !== 'not_saved');
        onTrailEngagementChange(id === ALL ? rest : [...rest, id as TrailEngagement]);
      }
    }
  };

  const completedConfig: SegmentedControlFilterConfigV2 = {
    type: 'segmented-control',
    id: 'completed-status',
    segmentedControl: {
      activeId: completedActiveId,
      ariaLabel: intl.formatMessage({ defaultMessage: 'Completion status' }),
      options: [
        { id: ALL, label: intl.formatMessage({ defaultMessage: 'All' }) },
        { id: 'completed', label: intl.formatMessage({ defaultMessage: 'Completed' }) },
        { id: 'not_completed', label: intl.formatMessage({ defaultMessage: 'Not completed' }) }
      ],
      onChange: id => {
        const rest = trailEngagement.filter(engagement => engagement !== 'completed' && engagement !== 'not_completed');
        onTrailEngagementChange(id === ALL ? rest : [...rest, id as TrailEngagement]);
      }
    }
  };

  return { completedConfig, savedConfig };
};

export default useMyTrailsSegmentedConfig;
